'use strict';

require('fancybox')(window.$);
require('jquery-lazyload');
require('notice');

$(document).ready
(
    function()
    {
        $('IMG.lazy').lazyload();
    }
);

$(document).ready
(
    function()
    {
        $('[data-notice]').notice({
            text: $('[data-notice] [data-notice-text]'),
            close: $('[data-notice] [data-notice-close]')
        });
    }
);

$(document).ready
(
    function()
    {
        $('A[target="_pop"]').fancybox();
    }
);

$(document).ready
(
    function()
    {
        $('[data-menu-trigger]').click
        (
            function()
            {
                if($(this).hasClass('burger--active'))
                {
                    $(this).removeClass('burger--active');
                    $('[data-menu-top]').slideUp(400);
                }
                else
                {
                    $(this).addClass('burger--active');
                    $('[data-menu-top]').slideDown(400);
                }
            }
        );
    }
);

$(document).ready
(
   function()
   {
       $('[data-menu-top] > .menu__item').hover
       (
           function()
           {
               if($(this).find("> .menu__item.menu__item--sub").length && window.outerWidth > 1200)
               {
                   $(this).find("> .menu__item.menu__item--sub").stop().animate(
                       {
                           height: 'show',
                           opacity: 'show'
                       },
                   400);
               }
           },
           function()
           {
               $(this).find("> .menu__item.menu__item--sub").stop().animate(
                   {
                       height: 'hide',
                       opacity: 'hide'
                   },
               400);
           },
       )
   }
);

$(document).ready
(
    function()
    {
        const $header = $('[data-header]');
        const $body = $('BODY');

        function onScroll()
        {
            if($body.scrollTop() >= 0 && $body.scrollTop() <= 400)
            {
                if($header.find('[data-notice]').length)
                {
                    $header
                    .removeClass("header--fix-notice");
                }
                else
                {
                    $header
                    .removeClass("header--fix-no-notice");
                }

                $header
                .removeClass("header--fix");
            }
            else
            {
                if($header.find('[data-notice]').length)
                {
                    $header
                    .addClass("header--fix-notice");
                }
                else
                {
                    $header
                    .addClass("header--fix-no-notice");
                }

                $header
                .addClass("header--fix");
            }
        }

        $(window).on('scroll', onScroll);

        onScroll();
    }
);

$(document).ready
(
    function()
    {
        $("[data-link-store]").click
        (
            function()
            {
                let me = this;

                if(typeof ga != 'undefined')
                {
                    ga('send', 'event', 'go', 'store');
                }

                if(typeof fbq != 'undefined')
                {
                    // fbq('track', 'ViewContent');
                }

                window.open($(me).attr("href"), '_blank');

                return false;
            }
        );
    }
);
